// Single source of truth for money formatting. Pure, dependency-free, so both
// the Worker (src/format.ts) and the browser UI (src/ui) import it — no drift.
// Money is integer minor units; display divides by 100.

const SYMBOLS: Record<string, string> = {
  EUR: "€",
  USD: "$",
  GBP: "£",
  JPY: "¥",
  INR: "₹",
  BDT: "৳",
};

export function symbolFor(ccy: string): string {
  return SYMBOLS[ccy] ?? "";
}

/** Base-currency money: symbol + 2 decimals. No-symbol form: "RSD 42.00". */
export function money(minor: number, ccy: string): string {
  const sym = symbolFor(ccy);
  const val = (Math.abs(minor) / 100).toFixed(2);
  const sign = minor < 0 ? "−" : "";
  return sym ? `${sign}${sym}${val}` : `${sign}${ccy} ${val}`;
}

/** Signed with explicit + for positives (balance deltas / net positions). */
export function signedMoney(minor: number, ccy: string): string {
  const sym = symbolFor(ccy);
  const val = (Math.abs(minor) / 100).toFixed(2);
  const sign = minor < 0 ? "−" : "+";
  return sym ? `${sign}${sym}${val}` : `${sign}${ccy} ${val}`;
}

/** Original currency as entered. No-symbol form: "42.00 RSD". */
export function originalMoney(minor: number, ccy: string): string {
  const sym = symbolFor(ccy);
  const val = (minor / 100).toFixed(2);
  return sym ? `${sym}${val}` : `${val} ${ccy}`;
}
